import i18n from 'i18next';

export enum Language {
  DUTCH = 'NL',
  ENGLISH = 'EN',
}

export const language = (): Language => {
  try {
    const baseLanguage = i18n.language;
    switch (baseLanguage) {
      case 'en':
        return Language.ENGLISH;
      case 'nl':
        return Language.DUTCH;
      default:
        return Language.ENGLISH;
    }
  } catch (error) {
    return Language.DUTCH;
  }
};
